//TODO: determine at some future date if we want to treat this as an error or not
// oxlint-disable no-inner-declarations
import { z } from 'zod';
import { CrewClaimResolutionMethodEnum, CrewIncentiveTypeEnum, InventoryBehavior, } from '../../enums/crew.js';
import { ClaimResolutionMethodEnum } from '../../enums/gsp.js';
import { mapped } from '../../typing.js';
import { UploadContentType } from '../../uploadMedia.js';
import { enumToZodLiteralUnion, helperSchema, optionalizeString, } from '../../zodExtensions.js';
// oxlint-disable-next-line @typescript-eslint/no-namespace
export var Pegasus;
(function (Pegasus) {
    let Operator;
    (function (Operator) {
        Operator["equal"] = "equal";
        Operator["notEqual"] = "notEqual";
        Operator["lessThan"] = "lessThan";
        Operator["greaterThan"] = "greaterThan";
        Operator["in"] = "in";
        Operator["notIn"] = "notIn";
        Operator["contains"] = "contains";
        Operator["doesNotContain"] = "doesNotContain";
    })(Operator = Pegasus.Operator || (Pegasus.Operator = {}));
    // ? possibly `concept/integration/data`
    let Fact;
    (function (Fact) {
        // order lookup
        Fact["orderDaysSinceCreated"] = "order/daysSinceCreated";
        Fact["statusCustomer"] = "status/customer";
        // ? the channel the registration was made on (eg, Costco, Amazon, etc)
        Fact["registrationChannel"] = "registration/channel";
        Fact["registrationEstimatedPurchaseDate"] = "registration/estimatedPurchaseDate";
        Fact["registrationDaysSincePurchaseEstimate"] = "registration/daysSincePurchaseEstimate";
        Fact["registrationEmailMarketingConsentCollected"] = "registration/emailMarketingConsentCollected";
        Fact["registrationNewCustomerCreated"] = "registration/newCustomerCreated";
        Fact["orderLineItemCustomPropertyName"] = "order/lineItem/customProperty/name";
        Fact["orderLineItemCompareAtPricePercentage"] = "order/lineItem/compareAtPricePercentage";
        Fact["orderDiscountCode"] = "order/discountCode";
        Fact["orderFinancialStatus"] = "order/financialStatus";
        Fact["orderCreated"] = "order/created";
        Fact["orderChannel"] = "order/channel";
        Fact["orderGateway"] = "order/gateway";
        Fact["orderIsGlobalE"] = "order/isGlobalE";
        Fact["orderCountry"] = "order/country";
        Fact["orderProvince"] = "order/province";
        Fact["orderTotal"] = "order/total";
        Fact["orderTags"] = "order/tags";
        Fact["orderCanceled"] = "order/canceled";
        Fact["orderFulfillmentDisplayStatus"] = "order/fulfillmentDisplayStatus";
        Fact["orderProtectedByCorso"] = "order/protectedByCorso";
        Fact["orderShippingLineTitle"] = "order/shippingLine/title";
        Fact["orderRechargeProtectedPrepaid"] = "order/recharge/protectedPrepaid";
        Fact["orderFulfillmentLocationId"] = "order/fulfillmentLocationId";
        Fact["orderNumber"] = "order/number";
        Fact["customerSegmentId"] = "customer/segmentId";
        Fact["customerTags"] = "customer/tags";
        Fact["customerEmail"] = "customer/email";
        Fact["customerTotalReturnCountLastYear"] = "customer/totalReturnCount/lastYear";
        Fact["customerTotalWarrantyCountLastYear"] = "customer/totalWarrantyCount/lastYear";
        Fact["customerTotalOrderCountAllTime"] = "customer/totalOrderCount/allTime";
        Fact["exchangeOrderTotal"] = "exchangeOrder/total";
        // after reason selection
        Fact["productVendor"] = "product/vendor";
        Fact["productTags"] = "product/tags";
        Fact["productTypes"] = "product/types";
        Fact["productCollections"] = "product/collections";
        Fact["productSku"] = "product/sku";
        Fact["productGroupId"] = "product/groupId";
        Fact["reasonId"] = "reason/id";
        Fact["reasonCategoryCode"] = "reason/categoryCode";
        Fact["reasonDetailId"] = "reason/detailId";
        Fact["claimType"] = "claim/type";
        Fact["claimTags"] = "claim/tags";
        Fact["claimTotal"] = "claim/total";
        Fact["claimRiskLevel"] = "claim/riskLevel";
        Fact["claimIsShopNow"] = "claim/isShopNow";
        Fact["claimLineItemRequestedResolutionMethod"] = "claimLineItem/requestedResolutionMethod";
        Fact["claimLineItemTotal"] = "claimLineItem/total";
        Fact["claimLineItemTotalQuantity"] = "claimLineItem/totalQuantity";
        Fact["claimLineItemCustomFieldResponse"] = "claimLineItem/customFieldResponse";
        Fact["claimLineItemInspectionGrade"] = "claimLineItem/inspectionGrade";
        Fact["claimLineItemWasResolvedExternally"] = "claimLineItem/wasResolvedExternally";
        Fact["claimIsGiftReturn"] = "claim/isGiftReturn";
        // claim created
        Fact["rmaStatus"] = "rma/status";
        Fact["rmaAllItemsReceived"] = "rma/allItemsReceived";
        Fact["rmaDisposition"] = "rma/disposition";
        Fact["returnShipmentStatus"] = "returnShipment/status";
        Fact["returnShipmentLocationId"] = "returnShipment/locationId";
        Fact["intelligemsTestGroupId"] = "intelligems/testGroupId";
        Fact["giftCardIssuedByCorso"] = "giftCard/issuedByCorso";
        // shipping claim
        Fact["shippingClaimTotal"] = "shippingClaim/total";
        Fact["shippingClaimResolutionMethod"] = "shippingClaim/resolutionMethod";
        Fact["shippingClaimReason"] = "shippingClaim/reason";
        Fact["shippingClaimLineItemReorderSku"] = "shippingClaimLineItem/reorderSku";
        Fact["userRole"] = "user/roleCode";
    })(Fact = Pegasus.Fact || (Pegasus.Fact = {}));
    let ValueType;
    (function (ValueType) {
        ValueType["numberArray"] = "numberArray";
        ValueType["stringArray"] = "stringArray";
        ValueType["number"] = "number";
        ValueType["boolean"] = "boolean";
        ValueType["date"] = "date";
    })(ValueType = Pegasus.ValueType || (Pegasus.ValueType = {}));
    Pegasus.valueTypeSchema = {
        [ValueType.stringArray]: z.array(z.string()),
        [ValueType.numberArray]: z.array(z.number()),
        [ValueType.number]: z.number(),
        [ValueType.boolean]: z.boolean(),
        [ValueType.date]: z.string().datetime(),
    };
    Pegasus.valueOperators = {
        [ValueType.numberArray]: [Operator.in, Operator.notIn],
        [ValueType.stringArray]: [
            Operator.in,
            Operator.notIn,
            Operator.contains,
            Operator.doesNotContain,
        ],
        [ValueType.number]: [
            Operator.lessThan,
            Operator.greaterThan,
            Operator.equal,
            Operator.notEqual,
        ],
        [ValueType.boolean]: [Operator.equal, Operator.notEqual],
        [ValueType.date]: [Operator.lessThan, Operator.greaterThan],
    };
    const arrayValueTypes = Object.values({
        [ValueType.stringArray]: ValueType.stringArray,
        [ValueType.numberArray]: ValueType.numberArray,
    });
    function isArrayValueType(valueType) {
        const compare = arrayValueTypes; // widen type for comparison; otherwise, TypeScript already expects they're different
        return compare.includes(valueType);
    }
    Pegasus.isArrayValueType = isArrayValueType;
    Pegasus.factValueType = {
        [Fact.orderCreated]: ValueType.date,
        [Fact.orderCountry]: ValueType.stringArray,
        [Fact.orderTotal]: ValueType.number,
        [Fact.orderTags]: ValueType.stringArray,
        [Fact.customerTags]: ValueType.stringArray,
        [Fact.rmaStatus]: ValueType.stringArray,
        [Fact.rmaAllItemsReceived]: ValueType.boolean,
        [Fact.returnShipmentStatus]: ValueType.stringArray,
        [Fact.productTags]: ValueType.stringArray,
        [Fact.productTypes]: ValueType.stringArray,
        [Fact.reasonId]: ValueType.numberArray,
        [Fact.reasonCategoryCode]: ValueType.stringArray,
        [Fact.reasonDetailId]: ValueType.numberArray,
        [Fact.claimType]: ValueType.stringArray,
        [Fact.orderNumber]: ValueType.stringArray,
        [Fact.customerEmail]: ValueType.stringArray,
        [Fact.orderChannel]: ValueType.stringArray,
        [Fact.orderProtectedByCorso]: ValueType.boolean,
        [Fact.claimLineItemRequestedResolutionMethod]: ValueType.stringArray,
        [Fact.productCollections]: ValueType.stringArray,
        [Fact.exchangeOrderTotal]: ValueType.number,
        [Fact.claimLineItemTotal]: ValueType.number,
        [Fact.claimLineItemCustomFieldResponse]: ValueType.stringArray,
        [Fact.orderDaysSinceCreated]: ValueType.number,
        [Fact.statusCustomer]: ValueType.boolean,
        [Fact.orderGateway]: ValueType.stringArray,
        [Fact.registrationChannel]: ValueType.stringArray,
        [Fact.registrationEstimatedPurchaseDate]: ValueType.date,
        [Fact.orderDiscountCode]: ValueType.stringArray,
        [Fact.claimTotal]: ValueType.number,
        [Fact.productVendor]: ValueType.stringArray,
        [Fact.productSku]: ValueType.stringArray,
        [Fact.productGroupId]: ValueType.numberArray,
        [Fact.customerTotalReturnCountLastYear]: ValueType.number,
        [Fact.customerTotalOrderCountAllTime]: ValueType.number,
        [Fact.orderProvince]: ValueType.stringArray,
        [Fact.orderFulfillmentLocationId]: ValueType.numberArray,
        [Fact.orderLineItemCompareAtPricePercentage]: ValueType.number,
        [Fact.intelligemsTestGroupId]: ValueType.stringArray,
        [Fact.customerSegmentId]: ValueType.numberArray,
        [Fact.orderFulfillmentDisplayStatus]: ValueType.stringArray,
        [Fact.orderCanceled]: ValueType.boolean,
        [Fact.orderFinancialStatus]: ValueType.stringArray,
        [Fact.registrationDaysSincePurchaseEstimate]: ValueType.number,
        [Fact.claimLineItemInspectionGrade]: ValueType.stringArray,
        [Fact.returnShipmentLocationId]: ValueType.numberArray,
        [Fact.claimLineItemTotalQuantity]: ValueType.number,
        [Fact.rmaDisposition]: ValueType.stringArray,
        [Fact.claimLineItemWasResolvedExternally]: ValueType.boolean,
        [Fact.claimIsGiftReturn]: ValueType.boolean,
        [Fact.claimRiskLevel]: ValueType.stringArray,
        [Fact.customerTotalWarrantyCountLastYear]: ValueType.number,
        [Fact.claimIsShopNow]: ValueType.boolean,
        [Fact.giftCardIssuedByCorso]: ValueType.boolean,
        [Fact.orderLineItemCustomPropertyName]: ValueType.stringArray,
        [Fact.registrationEmailMarketingConsentCollected]: ValueType.boolean,
        [Fact.registrationNewCustomerCreated]: ValueType.boolean,
        [Fact.orderShippingLineTitle]: ValueType.stringArray,
        [Fact.orderRechargeProtectedPrepaid]: ValueType.boolean,
        [Fact.claimTags]: ValueType.stringArray,
        [Fact.orderIsGlobalE]: ValueType.boolean,
        [Fact.shippingClaimTotal]: ValueType.number,
        [Fact.shippingClaimResolutionMethod]: ValueType.stringArray,
        [Fact.userRole]: ValueType.stringArray,
        [Fact.shippingClaimReason]: ValueType.stringArray,
        [Fact.shippingClaimLineItemReorderSku]: ValueType.stringArray,
    };
    /** Defines the expression for a fact with the operators, and value of it's associated value type. */
    const expression = (fact) => {
        const valueType = Pegasus.factValueType[fact];
        return z.object({
            fact: z.literal(`${fact}`),
            operator: z.union(mapped(Pegasus.valueOperators[valueType], (operator) => z.literal(`${operator}`))),
            value: Pegasus.valueTypeSchema[valueType],
        });
    };
    /** A utility value to use the array facts that are real. */
    Pegasus.arrayFacts = Object.values({
        [Fact.orderCountry]: Fact.orderCountry,
        [Fact.orderTags]: Fact.orderTags,
        [Fact.customerTags]: Fact.customerTags,
        [Fact.productTags]: Fact.productTags,
        [Fact.productTypes]: Fact.productTypes,
        [Fact.reasonId]: Fact.reasonId,
        [Fact.reasonCategoryCode]: Fact.reasonCategoryCode,
        [Fact.reasonDetailId]: Fact.reasonDetailId,
        [Fact.claimType]: Fact.claimType,
        [Fact.rmaStatus]: Fact.rmaStatus,
        [Fact.returnShipmentStatus]: Fact.returnShipmentStatus,
        [Fact.orderNumber]: Fact.orderNumber,
        [Fact.customerEmail]: Fact.customerEmail,
        [Fact.orderChannel]: Fact.orderChannel,
        [Fact.productCollections]: Fact.productCollections,
        [Fact.claimLineItemRequestedResolutionMethod]: Fact.claimLineItemRequestedResolutionMethod,
        [Fact.orderGateway]: Fact.orderGateway,
        [Fact.claimLineItemCustomFieldResponse]: Fact.claimLineItemCustomFieldResponse,
        [Fact.registrationChannel]: Fact.registrationChannel,
        [Fact.orderDiscountCode]: Fact.orderDiscountCode,
        [Fact.productVendor]: Fact.productVendor,
        [Fact.productSku]: Fact.productSku,
        [Fact.productGroupId]: Fact.productGroupId,
        [Fact.orderProvince]: Fact.orderProvince,
        [Fact.orderFulfillmentLocationId]: Fact.orderFulfillmentLocationId,
        [Fact.intelligemsTestGroupId]: Fact.intelligemsTestGroupId,
        [Fact.customerSegmentId]: Fact.customerSegmentId,
        [Fact.orderFulfillmentDisplayStatus]: Fact.orderFulfillmentDisplayStatus,
        [Fact.orderFinancialStatus]: Fact.orderFinancialStatus,
        [Fact.claimLineItemInspectionGrade]: Fact.claimLineItemInspectionGrade,
        [Fact.returnShipmentLocationId]: Fact.returnShipmentLocationId,
        [Fact.rmaDisposition]: Fact.rmaDisposition,
        [Fact.claimRiskLevel]: Fact.claimRiskLevel,
        [Fact.orderLineItemCustomPropertyName]: Fact.orderLineItemCustomPropertyName,
        [Fact.orderShippingLineTitle]: Fact.orderShippingLineTitle,
        [Fact.claimTags]: Fact.claimTags,
        [Fact.shippingClaimResolutionMethod]: Fact.shippingClaimResolutionMethod,
        [Fact.userRole]: Fact.userRole,
        [Fact.shippingClaimReason]: Fact.shippingClaimReason,
        [Fact.shippingClaimLineItemReorderSku]: Fact.shippingClaimLineItemReorderSku,
    });
    function isArrayFact(fact) {
        const compare = Pegasus.arrayFacts; // widen type for comparison; otherwise, TypeScript already expects they're different
        return compare.includes(fact);
    }
    Pegasus.isArrayFact = isArrayFact;
    let ArrayFactType;
    (function (ArrayFactType) {
        /**
         * Represents that the underlying value type is represented by any value of that type.
         * Arbitrary values are expected to be self-representing, so they are their own label at runtime.
         */
        ArrayFactType["arbitrary"] = "arbitrary";
        /**
         * Represents that the underlying value type is represented by a strict list of options.
         * This is often useful for facts that are primary keys, or other values that are strictly defined.
         * Any definite value is expected to have a `string` label associated with it at runtime.
         * These are enforced by a separate schema for the value.
         * @see `arrayFactDataSchema`
         */
        ArrayFactType["definite"] = "definite";
    })(ArrayFactType = Pegasus.ArrayFactType || (Pegasus.ArrayFactType = {}));
    Pegasus.arrayFactType = {
        [Fact.orderCountry]: ArrayFactType.definite,
        [Fact.orderTags]: ArrayFactType.arbitrary,
        [Fact.customerTags]: ArrayFactType.arbitrary,
        [Fact.rmaStatus]: ArrayFactType.arbitrary,
        [Fact.returnShipmentStatus]: ArrayFactType.definite,
        [Fact.productTags]: ArrayFactType.arbitrary,
        [Fact.productTypes]: ArrayFactType.arbitrary,
        [Fact.reasonId]: ArrayFactType.definite,
        [Fact.reasonCategoryCode]: ArrayFactType.definite,
        [Fact.reasonDetailId]: ArrayFactType.definite,
        [Fact.claimType]: ArrayFactType.definite,
        [Fact.orderNumber]: ArrayFactType.arbitrary,
        [Fact.customerEmail]: ArrayFactType.arbitrary,
        [Fact.orderChannel]: ArrayFactType.definite,
        [Fact.claimLineItemRequestedResolutionMethod]: ArrayFactType.definite,
        [Fact.productCollections]: ArrayFactType.arbitrary,
        [Fact.claimLineItemCustomFieldResponse]: ArrayFactType.definite,
        [Fact.orderGateway]: ArrayFactType.definite,
        [Fact.registrationChannel]: ArrayFactType.definite,
        [Fact.orderDiscountCode]: ArrayFactType.arbitrary,
        [Fact.productVendor]: ArrayFactType.arbitrary,
        [Fact.productSku]: ArrayFactType.arbitrary,
        [Fact.productGroupId]: ArrayFactType.definite,
        [Fact.orderProvince]: ArrayFactType.definite,
        [Fact.orderFulfillmentLocationId]: ArrayFactType.definite,
        [Fact.intelligemsTestGroupId]: ArrayFactType.arbitrary,
        [Fact.customerSegmentId]: ArrayFactType.definite,
        [Fact.orderFulfillmentDisplayStatus]: ArrayFactType.definite,
        [Fact.orderFinancialStatus]: ArrayFactType.definite,
        [Fact.claimLineItemInspectionGrade]: ArrayFactType.definite,
        [Fact.returnShipmentLocationId]: ArrayFactType.definite,
        [Fact.rmaDisposition]: ArrayFactType.definite,
        [Fact.claimRiskLevel]: ArrayFactType.definite,
        [Fact.orderLineItemCustomPropertyName]: ArrayFactType.arbitrary,
        [Fact.orderShippingLineTitle]: ArrayFactType.arbitrary,
        [Fact.claimTags]: ArrayFactType.arbitrary,
        [Fact.shippingClaimResolutionMethod]: ArrayFactType.definite,
        [Fact.userRole]: ArrayFactType.definite,
        [Fact.shippingClaimReason]: ArrayFactType.definite,
        [Fact.shippingClaimLineItemReorderSku]: ArrayFactType.arbitrary,
    };
    function isArbitraryFact(fact) {
        if (!isArrayFact(fact))
            return false;
        return Pegasus.arrayFactType[fact] === ArrayFactType.arbitrary;
    }
    Pegasus.isArbitraryFact = isArbitraryFact;
    const arbitraryValueTypes = Object.values({
        [ValueType.stringArray]: ValueType.stringArray,
    });
    function isArbitraryValueType(valueType) {
        const compare = arbitraryValueTypes; // widen type for comparison; otherwise, TypeScript already expects they're different
        return compare.includes(valueType);
    }
    Pegasus.isArbitraryValueType = isArbitraryValueType;
    function isDefiniteFact(fact) {
        if (!isArrayFact(fact))
            return false;
        return Pegasus.arrayFactType[fact] === ArrayFactType.definite;
    }
    Pegasus.isDefiniteFact = isDefiniteFact;
    const definiteValueTypes = Object.values({
        [ValueType.stringArray]: ValueType.stringArray,
        [ValueType.numberArray]: ValueType.numberArray,
    });
    function isDefiniteValueType(valueType) {
        const compare = definiteValueTypes; // widen type for comparison; otherwise, TypeScript already expects they're different
        return compare.includes(valueType);
    }
    Pegasus.isDefiniteValueType = isDefiniteValueType;
    Pegasus.EventType = {
        merchantPaidShippingProtection: 'merchantPaidShippingProtection',
        modifyResolutionWindow: 'modifyResolutionWindow',
        autoFinalizeClaim: 'autoFinalizeClaim',
        modifyIncentives: 'modifyIncentives',
        applyFee: 'applyFee',
        omitResolutionMethods: 'omitResolutionMethods',
        applyLineItemFee: 'applyLineItemFee',
        askAPolicyEnforcingQuestion: 'askAPolicyEnforcingQuestion',
        offerInstantExchange: 'offerInstantExchange',
        offerAdvancedExchange: 'offerAdvancedExchange',
        allowClaimTypeSelection: 'allowClaimTypeSelection',
        collectCustomFields: 'collectCustomFields',
        applyClaimTags: 'applyClaimTags',
        customizeClaimFinalizationSettings: 'customizeClaimFinalizationSettings',
        chargeForReturnLabel: 'chargeForReturnLabel',
        chargeForExchangeOrderShipping: 'chargeForExchangeOrderShipping',
        allowCustomerToKeepItem: 'allowCustomerToKeepItem',
        productRegistrationSelection: 'productRegistrationSelection',
        returnShippingConfig: 'returnShippingConfig',
        applyOrderTags: 'applyOrderTags',
        customizeClaimLineItemInspection: 'customizeClaimLineItemInspection',
        quoteOrderShipment: 'quoteOrderShipment',
        quoteOrderShipmentModify: 'quoteOrderShipmentModify',
        quoteOrderShipmentParcel: 'quoteOrderShipmentParcel',
        quoteOrderShipmentDeliveryEstimate: 'quoteOrderShipmentDeliveryEstimate',
        orderEditing: 'orderEditing',
        restockInventory: 'restockInventory',
        shopNow: 'shopNow',
        setOrderShippingTitle: 'setOrderShippingTitle',
        rightToWithdraw: 'rightToWithdraw',
        registrationDiscountIncentive: 'registrationDiscountIncentive',
        customizeReturnShipment: 'customizeReturnShipment',
        createGorgiasTicket: 'createGorgiasTicket',
        // shipping claim events
        shipClaimAllowedResolutions: 'shipClaimAllowedResolutions',
        shipApplyOrderTags: 'shipApplyOrderTags',
        shipClaimSlaAlert: 'shipClaimSlaAlert',
        shipClaimReorderLocations: 'shipClaimReorderLocations',
        shipClaimReorderShipping: 'shipClaimReorderShipping',
    };
    const contextualUsageOnlyEvents = [
        Pegasus.EventType.quoteOrderShipment,
        Pegasus.EventType.quoteOrderShipmentModify,
        Pegasus.EventType.quoteOrderShipmentParcel,
        Pegasus.EventType.quoteOrderShipmentDeliveryEstimate,
        Pegasus.EventType.merchantPaidShippingProtection,
        Pegasus.EventType.shopNow,
        Pegasus.EventType.orderEditing,
        // ? shipping claim
        Pegasus.EventType.shipClaimAllowedResolutions,
        Pegasus.EventType.shipClaimReorderLocations,
        Pegasus.EventType.shipClaimSlaAlert,
        Pegasus.EventType.shipClaimReorderShipping,
        Pegasus.EventType.shipApplyOrderTags,
    ];
    // TODO evaluate how events are hidden, and support dynamically hiding events and facts based on what's enabled
    Pegasus.hiddenEvents = [
        ...new Set(contextualUsageOnlyEvents),
    ];
    Pegasus.Hook = {
        registrationProductSelection: 'Registration_Product_Selection', // at registration product selection
        registrationCreated: 'Registration_Created', // at registration created
        orderLookup: 'Order_Lookup', // at order lookup
        claimCreated: 'Claim_Created', // at claim created
        claimLineItemReview: 'Claim_Line_Item_Review', // at claim line item review
        afterReasonSelection: 'After_Reason_Selection', // after reason selection
        beforeClaimSubmission: 'Before_Claim_Submission', // before claim submission
        rmaWebhook: 'RMA_Webhook', // at rma webhook
        returnShipmentWebhook: 'Return_Shipment_Webhook', // at return shipment webhook
        claimFinalized: 'Claim_Finalized', // at claim finalize
        returnShipmentCreated: 'Return_Shipment_Created', // at return shipment purchased
        returnShipmentQuote: 'Return_Shipment_Quote', // at return shipment quote
        beforeClaimLineItemInspection: 'Before_Claim_Line_Item_Inspection', // before claim line item inspection
        orderCheckoutBegin: 'Order_Checkout_Begin', // at order checkout start
        orderCheckoutQuoteShipping: 'Order_Checkout_Quote_Shipping', // at order checkout quote shipping
        exchangeProductSelection: 'Exchange_Product_Selection', // at variant exchange start
        shippingClaimLookup: 'Shipping_Claim_Lookup', // at shipping claim lookup
        shippingClaimFinalized: 'Shipping_Claim_Finalized', // at shipping claim finalize
        orderCreated: 'Order_Created', // at order created
    };
    // ? This is the order the StoreRulesAsFlow component renders the hooks in
    // TODO evaluate a better way to represent sets/subsets of hooks within a category
    Pegasus.returnOrWarrantyHook = [
        Pegasus.Hook.orderLookup,
        Pegasus.Hook.afterReasonSelection,
        Pegasus.Hook.exchangeProductSelection,
        Pegasus.Hook.claimLineItemReview,
        Pegasus.Hook.returnShipmentQuote,
        Pegasus.Hook.beforeClaimSubmission,
        Pegasus.Hook.claimCreated,
        Pegasus.Hook.returnShipmentCreated,
        Pegasus.Hook.returnShipmentWebhook,
        Pegasus.Hook.rmaWebhook,
        Pegasus.Hook.beforeClaimLineItemInspection,
        Pegasus.Hook.claimFinalized,
    ];
    // ------ fact expressions ---------------------
    Pegasus.factExpression = {
        [Fact.orderCreated]: expression(Fact.orderCreated),
        [Fact.orderCountry]: expression(Fact.orderCountry),
        [Fact.orderTotal]: expression(Fact.orderTotal),
        [Fact.orderTags]: expression(Fact.orderTags),
        [Fact.customerTags]: expression(Fact.customerTags),
        [Fact.rmaStatus]: expression(Fact.rmaStatus),
        [Fact.rmaAllItemsReceived]: expression(Fact.rmaAllItemsReceived),
        [Fact.returnShipmentStatus]: expression(Fact.returnShipmentStatus),
        [Fact.productTags]: expression(Fact.productTags),
        [Fact.productTypes]: expression(Fact.productTypes),
        [Fact.reasonId]: expression(Fact.reasonId),
        [Fact.reasonCategoryCode]: expression(Fact.reasonCategoryCode),
        [Fact.reasonDetailId]: expression(Fact.reasonDetailId),
        [Fact.claimType]: expression(Fact.claimType),
        [Fact.orderNumber]: expression(Fact.orderNumber),
        [Fact.customerEmail]: expression(Fact.customerEmail),
        [Fact.orderChannel]: expression(Fact.orderChannel),
        [Fact.orderProtectedByCorso]: expression(Fact.orderProtectedByCorso),
        [Fact.claimLineItemRequestedResolutionMethod]: expression(Fact.claimLineItemRequestedResolutionMethod),
        [Fact.orderDaysSinceCreated]: expression(Fact.orderDaysSinceCreated),
        [Fact.productCollections]: expression(Fact.productCollections),
        [Fact.exchangeOrderTotal]: expression(Fact.exchangeOrderTotal),
        [Fact.claimLineItemTotal]: expression(Fact.claimLineItemTotal),
        [Fact.statusCustomer]: expression(Fact.statusCustomer),
        [Fact.claimLineItemCustomFieldResponse]: expression(Fact.claimLineItemCustomFieldResponse),
        [Fact.orderGateway]: expression(Fact.orderGateway),
        [Fact.registrationChannel]: expression(Fact.registrationChannel),
        [Fact.registrationEstimatedPurchaseDate]: expression(Fact.registrationEstimatedPurchaseDate),
        [Fact.orderDiscountCode]: expression(Fact.orderDiscountCode),
        [Fact.claimTotal]: expression(Fact.claimTotal),
        [Fact.productVendor]: expression(Fact.productVendor),
        [Fact.productSku]: expression(Fact.productSku),
        [Fact.productGroupId]: expression(Fact.productGroupId),
        [Fact.customerTotalReturnCountLastYear]: expression(Fact.customerTotalReturnCountLastYear),
        [Fact.customerTotalOrderCountAllTime]: expression(Fact.customerTotalOrderCountAllTime),
        [Fact.orderProvince]: expression(Fact.orderProvince),
        [Fact.orderFulfillmentLocationId]: expression(Fact.orderFulfillmentLocationId),
        [Fact.orderLineItemCompareAtPricePercentage]: expression(Fact.orderLineItemCompareAtPricePercentage),
        [Fact.intelligemsTestGroupId]: expression(Fact.intelligemsTestGroupId),
        [Fact.customerSegmentId]: expression(Fact.customerSegmentId),
        [Fact.orderFulfillmentDisplayStatus]: expression(Fact.orderFulfillmentDisplayStatus),
        [Fact.orderCanceled]: expression(Fact.orderCanceled),
        [Fact.orderFinancialStatus]: expression(Fact.orderFinancialStatus),
        [Fact.registrationDaysSincePurchaseEstimate]: expression(Fact.registrationDaysSincePurchaseEstimate),
        [Fact.claimLineItemInspectionGrade]: expression(Fact.claimLineItemInspectionGrade),
        [Fact.returnShipmentLocationId]: expression(Fact.returnShipmentLocationId),
        [Fact.claimLineItemTotalQuantity]: expression(Fact.claimLineItemTotalQuantity),
        [Fact.rmaDisposition]: expression(Fact.rmaDisposition),
        [Fact.claimLineItemWasResolvedExternally]: expression(Fact.claimLineItemWasResolvedExternally),
        [Fact.claimIsGiftReturn]: expression(Fact.claimIsGiftReturn),
        [Fact.claimRiskLevel]: expression(Fact.claimRiskLevel),
        [Fact.customerTotalWarrantyCountLastYear]: expression(Fact.customerTotalWarrantyCountLastYear),
        [Fact.claimIsShopNow]: expression(Fact.claimIsShopNow),
        [Fact.giftCardIssuedByCorso]: expression(Fact.giftCardIssuedByCorso),
        [Fact.orderLineItemCustomPropertyName]: expression(Fact.orderLineItemCustomPropertyName),
        [Fact.registrationEmailMarketingConsentCollected]: expression(Fact.registrationEmailMarketingConsentCollected),
        [Fact.registrationNewCustomerCreated]: expression(Fact.registrationNewCustomerCreated),
        [Fact.orderShippingLineTitle]: expression(Fact.orderShippingLineTitle),
        [Fact.orderRechargeProtectedPrepaid]: expression(Fact.orderRechargeProtectedPrepaid),
        [Fact.claimTags]: expression(Fact.claimTags),
        [Fact.orderIsGlobalE]: expression(Fact.orderIsGlobalE),
        [Fact.shippingClaimTotal]: expression(Fact.shippingClaimTotal),
        [Fact.shippingClaimResolutionMethod]: expression(Fact.shippingClaimResolutionMethod),
        [Fact.userRole]: expression(Fact.userRole),
        [Fact.shippingClaimReason]: expression(Fact.shippingClaimReason),
        [Fact.shippingClaimLineItemReorderSku]: expression(Fact.shippingClaimLineItemReorderSku),
    };
    // !  WHEN ADDING A FACT, REMEMBER TO PUT IT HERE FOR GOD'S SAKE
    // ! FUCKING KILL ME
    // TODO find a way to enforce that all fact expressions are represented here at compile time; then the related test can be removed
    Pegasus.expressionSchema = z.discriminatedUnion('fact', [
        Pegasus.factExpression[Fact.shippingClaimResolutionMethod],
        Pegasus.factExpression[Fact.shippingClaimTotal],
        Pegasus.factExpression[Fact.orderIsGlobalE],
        Pegasus.factExpression[Fact.shippingClaimReason],
        Pegasus.factExpression[Fact.userRole],
        Pegasus.factExpression[Fact.orderShippingLineTitle],
        Pegasus.factExpression[Fact.orderCreated],
        Pegasus.factExpression[Fact.orderCountry],
        Pegasus.factExpression[Fact.orderTotal],
        Pegasus.factExpression[Fact.orderTags],
        Pegasus.factExpression[Fact.customerTags],
        Pegasus.factExpression[Fact.rmaStatus],
        Pegasus.factExpression[Fact.rmaAllItemsReceived],
        Pegasus.factExpression[Fact.returnShipmentStatus],
        Pegasus.factExpression[Fact.productTags],
        Pegasus.factExpression[Fact.productTypes],
        Pegasus.factExpression[Fact.reasonId],
        Pegasus.factExpression[Fact.reasonCategoryCode],
        Pegasus.factExpression[Fact.reasonDetailId],
        Pegasus.factExpression[Fact.claimType],
        Pegasus.factExpression[Fact.orderNumber],
        Pegasus.factExpression[Fact.customerEmail],
        Pegasus.factExpression[Fact.orderChannel],
        Pegasus.factExpression[Fact.orderProtectedByCorso],
        Pegasus.factExpression[Fact.claimLineItemRequestedResolutionMethod],
        Pegasus.factExpression[Fact.exchangeOrderTotal],
        Pegasus.factExpression[Fact.claimLineItemTotal],
        Pegasus.factExpression[Fact.productCollections],
        Pegasus.factExpression[Fact.claimLineItemCustomFieldResponse],
        Pegasus.factExpression[Fact.orderDaysSinceCreated],
        Pegasus.factExpression[Fact.statusCustomer],
        Pegasus.factExpression[Fact.orderGateway],
        Pegasus.factExpression[Fact.registrationEstimatedPurchaseDate],
        Pegasus.factExpression[Fact.registrationChannel],
        Pegasus.factExpression[Fact.orderDiscountCode],
        Pegasus.factExpression[Fact.claimTotal],
        Pegasus.factExpression[Fact.productVendor],
        Pegasus.factExpression[Fact.productSku],
        Pegasus.factExpression[Fact.shippingClaimLineItemReorderSku],
        Pegasus.factExpression[Fact.productGroupId],
        Pegasus.factExpression[Fact.customerTotalReturnCountLastYear],
        Pegasus.factExpression[Fact.customerTotalOrderCountAllTime],
        Pegasus.factExpression[Fact.orderProvince],
        Pegasus.factExpression[Fact.orderFulfillmentLocationId],
        Pegasus.factExpression[Fact.orderLineItemCompareAtPricePercentage],
        Pegasus.factExpression[Fact.intelligemsTestGroupId],
        Pegasus.factExpression[Fact.customerSegmentId],
        Pegasus.factExpression[Fact.orderFulfillmentDisplayStatus],
        Pegasus.factExpression[Fact.orderCanceled],
        Pegasus.factExpression[Fact.orderFinancialStatus],
        Pegasus.factExpression[Fact.registrationDaysSincePurchaseEstimate],
        Pegasus.factExpression[Fact.claimLineItemInspectionGrade],
        Pegasus.factExpression[Fact.returnShipmentLocationId],
        Pegasus.factExpression[Fact.claimLineItemTotalQuantity],
        Pegasus.factExpression[Fact.rmaDisposition],
        Pegasus.factExpression[Fact.claimLineItemWasResolvedExternally],
        Pegasus.factExpression[Fact.claimIsGiftReturn],
        Pegasus.factExpression[Fact.claimRiskLevel],
        Pegasus.factExpression[Fact.customerTotalWarrantyCountLastYear],
        Pegasus.factExpression[Fact.claimIsShopNow],
        Pegasus.factExpression[Fact.giftCardIssuedByCorso],
        Pegasus.factExpression[Fact.orderLineItemCustomPropertyName],
        Pegasus.factExpression[Fact.registrationEmailMarketingConsentCollected],
        Pegasus.factExpression[Fact.registrationNewCustomerCreated],
        Pegasus.factExpression[Fact.orderRechargeProtectedPrepaid],
        Pegasus.factExpression[Fact.claimTags],
    ]);
    const allConditionSchema = z.object({
        all: z.array(Pegasus.expressionSchema),
    });
    const anyConditionSchema = z.object({
        any: z.array(Pegasus.expressionSchema),
    });
    Pegasus.eventClaimFinalizationSettings = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.customizeClaimFinalizationSettings}`),
        params: z.object({
            inventoryBehavior: enumToZodLiteralUnion(InventoryBehavior).optional(),
            failOnOutOfStockScenarios: z.boolean(),
            allowFulfillmentLocationIds: z.array(z.number()).optional(),
        }),
    });
    Pegasus.eventAllowCustomerToKeepItem = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.allowCustomerToKeepItem}`),
        params: z.object({
        // ? we might need to add a message to display after a yes selection
        }),
    });
    // ------------ policy enforcement question ------------
    const markAsIneligible = z.literal('markAsIneligible');
    Pegasus.eventPolicyEnforcement = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.askAPolicyEnforcingQuestion}`),
        params: z.object({
            question: helperSchema.nonEmptyString,
            // ? optional message to display after a yes selection
            onYesMessage: z.string().optional(),
            yes: markAsIneligible,
            no: z.null(), // ! do nothing
        }),
    });
    Pegasus.eventAllowClaimTypeSelection = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.allowClaimTypeSelection}`),
        params: z.object({
            claimTypeSelectionDetailText: helperSchema.nonEmptyString,
            returnSelectionButtonTitle: helperSchema.optionalizedString,
        }),
    });
    const tagWithoutId = z.object({
        name: z.string(),
    });
    Pegasus.eventApplyClaimTags = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.applyClaimTags}`),
        params: z.object({
            claimTags: z.array(tagWithoutId),
        }),
    });
    Pegasus.OrderTagActionTarget = {
        Replacement_Order: 'Replacement Order',
        Original_Order: 'Original Order',
    };
    Pegasus.eventApplyOrderTags = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.applyOrderTags}`),
        params: z.object({
            orderTagAction: z.enum(Pegasus.OrderTagActionTarget),
            orderTags: z.array(tagWithoutId),
            tagWithReason: z.boolean().optional(),
        }),
    });
    // auto finalize claim
    const allowedResolutionMethodOptions = z.array(z.union([
        z.literal(`${CrewClaimResolutionMethodEnum.refund}`),
        z.literal(`${CrewClaimResolutionMethodEnum.giftCard}`),
        z.literal(`${CrewClaimResolutionMethodEnum.variantExchange}`),
    ]));
    // resolution methods that can be omitted from a line item's eligibility
    Pegasus.omittedResolutionMethodOptions = z.array(z.union([
        z.literal(`${CrewClaimResolutionMethodEnum.refund}`),
        z.literal(`${CrewClaimResolutionMethodEnum.giftCard}`),
    ]));
    Pegasus.eventOmitResolutionMethods = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.omitResolutionMethods}`),
        params: z.object({
            omittedResolutionMethods: Pegasus.omittedResolutionMethodOptions.min(1, 'Please select at least one resolution method to omit'),
        }),
    });
    Pegasus.eventAutoFinalizeClaim = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.autoFinalizeClaim}`),
        params: z.object({
            // todo: remove this after fully moving off it in favor of conditions
            allowedResolutionMethods: allowedResolutionMethodOptions.optional(),
        }),
    });
    const ineligibleLineItemFootnoteSchema = optionalizeString(z
        .string()
        .max(30, {
        message: 'Footnote must be less than 30 characters',
    })
        .trim());
    const eligibilityDaysSchema = helperSchema.policyDays.nullish();
    Pegasus.eventModifyResolutionWindow = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.modifyResolutionWindow}`),
        // might need to XOR dates so that at least one is required; otherwise, this wouldn't do anything if nothing was specified
        params: z.discriminatedUnion('kind', [
            z.object({
                kind: z.literal('returnableUntil'),
                ineligibleLineItemFootnote: ineligibleLineItemFootnoteSchema,
                refund: helperSchema.optionalizedDatetime,
                giftCard: helperSchema.optionalizedDatetime,
                exchange: helperSchema.optionalizedDatetime, // ? should this be `variantExchange`
                warrantyReview: helperSchema.optionalizedDatetime,
                isIneligibleWarrantyClaimAllowed: z.boolean().optional(),
                ineligibleWarrantyClaimTitle: z.string().optional(),
                ineligibleWarrantyClaimDisclaimer: z.string().optional(),
            }),
            z.object({
                kind: z.literal('eligibilityDays'),
                ineligibleLineItemFootnote: ineligibleLineItemFootnoteSchema,
                refund: eligibilityDaysSchema,
                giftCard: eligibilityDaysSchema,
                exchange: eligibilityDaysSchema, // ? should this be `variantExchange`
                warrantyReview: eligibilityDaysSchema,
                isIneligibleWarrantyClaimAllowed: z.boolean().optional(),
                ineligibleWarrantyClaimTitle: z.string().optional(),
                ineligibleWarrantyClaimDisclaimer: z.string().optional(),
            }),
        ]),
    });
    Pegasus.eventCollectCustomFieldsParams = z.object({
        customFieldIds: z.array(z.number()),
        showDefaultCommentField: z.boolean(),
        isDefaultCommentFieldRequired: z.boolean().optional(),
        isMediaUploadRequired: z.boolean(),
        mediaUploadInstructions: z.string().optional(),
        minimumMediaUploadAmount: z.number().optional(),
        allowedContentTypes: z
            .array(z.enum(UploadContentType))
            .min(1, 'Please select at least one media type')
            .default([
            UploadContentType.image,
            UploadContentType.video,
            UploadContentType.pdf,
        ]),
    });
    Pegasus.eventCollectCustomFields = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.collectCustomFields}`),
        params: Pegasus.eventCollectCustomFieldsParams,
    });
    Pegasus.GorgiasTicketTemplateVars = {
        claimName: `claimName`,
        claimType: `claimType`,
        customerEmail: `customerEmail`,
        merchantAppUrl: 'merchantAppUrl',
    };
    Pegasus.eventCreateGorgiasTicket = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.createGorgiasTicket}`),
        params: z.object({
            subject: helperSchema.nonEmptyString,
            assigneeTeamId: z.number().optional(),
            shouldAssignSender: z.boolean().optional(),
            body: helperSchema.optionalizedString,
            // must be a user in Gorgias
            senderEmail: z.email(),
            tags: z.array(z.string()).optional(),
        }),
    });
    Pegasus.eventCustomizeClaimLineItemInspection = z.object({
        type: z.literal(`${Pegasus.EventType.customizeClaimLineItemInspection}`),
        storeRuleId: z.number().optional(),
        params: z.object({
            inspectionCustomFieldIds: z.array(z.number()),
            showInspectionComment: z.boolean(),
            showInspectionMediaUpload: z.boolean(),
            shouldCollectInspectionGrade: z.boolean(),
            inspectionInstructions: helperSchema.optionalizedString,
        }),
    });
    // ? possibly elevate into zod extensions
    function shouldModify(schema) {
        return z.discriminatedUnion('shouldModify', [
            z.object({ shouldModify: z.literal(false) }),
            schema.merge(z.object({ shouldModify: z.literal(true) })),
        ]);
    }
    Pegasus.shouldModify = shouldModify;
    Pegasus.eventModifyIncentives = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.modifyIncentives}`),
        params: z.object({
            giftCardIncentive: shouldModify(z.object({
                amount: helperSchema.nonNegativeNumber,
                type: enumToZodLiteralUnion(CrewIncentiveTypeEnum),
            })),
        }),
    });
    Pegasus.eventChargeForReturnLabel = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.chargeForReturnLabel}`),
        params: z.object({
            applyLabelMarkup: shouldModify(z.object({
                amount: helperSchema.nonNegativeNumber,
                type: enumToZodLiteralUnion(CrewIncentiveTypeEnum),
            })),
        }),
    });
    Pegasus.eventProductRegistrationSelection = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.productRegistrationSelection}`),
        params: z.object({
            productRegistrationProductGroupId: z
                .string()
                .or(z.number())
                .pipe(z.coerce.number())
                .pipe(z.number().gt(0, 'Please select a Product Group')),
        }),
    });
    // ------------- return shipment quote ---------------------
    Pegasus.ReturnHandling = {
        returnLocation: 'Return_Location',
        globalE: 'Global_E',
    };
    const returnLocationShippingConfig = z.object({
        // `.optional()` lets the discriminated union match rules stored before this
        // field existed; `.default()` then stamps them as return-location policies
        returnHandling: z
            .literal(Pegasus.ReturnHandling.returnLocation)
            .optional()
            .default(Pegasus.ReturnHandling.returnLocation),
        returnMethods: z
            .array(z.union([z.literal('Label'), z.literal('Packing_Slip')]))
            .min(1, 'Please select at least one Return Method'),
        returnLocationId: z
            .string()
            .or(z.number())
            .pipe(z.coerce.number())
            .pipe(z.number().gt(0, 'Please select a Return Location')),
    });
    // Global-e owns both the destination and the label, so there is nothing for the
    // merchant to pick — the countries it applies to are the rule's own conditions
    const globalEShippingConfig = z.object({
        returnHandling: z.literal(Pegasus.ReturnHandling.globalE),
    });
    Pegasus.eventReturnShippingConfig = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.returnShippingConfig}`),
        params: z.discriminatedUnion('returnHandling', [
            returnLocationShippingConfig,
            globalEShippingConfig,
        ]),
    });
    Pegasus.eventChargeForExchangeOrderShipping = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.chargeForExchangeOrderShipping}`),
        params: z.object({
            applyExchangeOrderShippingMarkup: shouldModify(z.object({
                amount: helperSchema.nonNegativeNumber,
                type: enumToZodLiteralUnion(CrewIncentiveTypeEnum),
            })),
        }),
    });
    const applyFeeParams = z.object({
        feeDisplayName: z.string(),
        feeAmount: z.number().nonnegative(),
        feeType: enumToZodLiteralUnion(CrewIncentiveTypeEnum).default('Fixed'),
    });
    Pegasus.eventApplyFee = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.applyFee}`),
        params: applyFeeParams,
    });
    Pegasus.eventApplyLineItemFee = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.applyLineItemFee}`),
        params: applyFeeParams.extend({
            applyPerItem: z.boolean().default(false),
        }),
    });
    // ------------ offer shop now ------------
    Pegasus.ShopNowBenefitKind = {
        incentive: 'incentive',
        informational: 'informational',
    };
    Pegasus.ShopNowIcon = {
        DollarSign: 'DollarSign',
        MagnifyingGlass: 'MagnifyingGlass',
        Truck: 'Truck',
        ArrowRightArrowLeft: 'ArrowRightArrowLeft',
    };
    // TODO: verify lengths on the schemas
    const baseBenefit = z.object({
        label: helperSchema.nonEmptyString.max(36, 'Label must be less than 36 characters'),
        description: helperSchema.nonEmptyString.max(150, 'Description must be less than 100 characters'),
        icon: enumToZodLiteralUnion(Pegasus.ShopNowIcon).optional(),
    });
    const informationalBenefit = baseBenefit.extend({
        kind: z.literal(Pegasus.ShopNowBenefitKind.informational),
    });
    const incentiveBenefit = baseBenefit.extend({
        kind: z.literal(Pegasus.ShopNowBenefitKind.incentive),
        incentive: z.object({
            amount: helperSchema.nonNegativeNumber,
            type: z.union([
                z.literal(CrewIncentiveTypeEnum.fixed),
                z.literal(CrewIncentiveTypeEnum.percent),
            ]),
        }),
    });
    Pegasus.ShopNowBenefit = z.discriminatedUnion('kind', [
        informationalBenefit,
        incentiveBenefit,
    ]);
    Pegasus.shopNowEventParams = z.object({
        startShoppingUrl: z.string().url().min(1, 'Start Shopping URL is required'),
        // TODO: add error messaging
        shopNowBenefits: z
            .array(Pegasus.ShopNowBenefit)
            .max(4, 'Please add up to 4 benefits'),
    });
    Pegasus.eventShopNow = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.shopNow}`),
        params: Pegasus.shopNowEventParams,
    });
    Pegasus.eventOfferInstantExchangeParams = z.object({
        timeToReturnBeforeCharging: z.literal(7), // ! this can be altered once we determine how Stripe interacts with us for pre-authorizations
        isInstantExchangeRequired: z.boolean().default(false),
        instantExchangeDescriptionText: z.string().optional(),
    });
    Pegasus.eventOfferInstantExchange = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.offerInstantExchange}`),
        params: Pegasus.eventOfferInstantExchangeParams,
    });
    Pegasus.eventQuoteOrderShipment = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.quoteOrderShipment}`),
        params: z.object({
            storeShipRateIds: z.array(z.number()),
        }),
    });
    // ------------- quote order shipment modify ---------------------
    Pegasus.QuoteModification = {
        APPLY_FIXED_FEE: 'APPLY_FIXED_FEE',
        APPLY_PERCENTAGE_FEE: 'APPLY_PERCENTAGE_FEE',
        ADD_OR_REMOVE_RATES: 'ADD_OR_REMOVE_RATES',
        APPLY_SHIPPING_DISCOUNT: 'APPLY_SHIPPING_DISCOUNT',
    };
    Pegasus.USHoliday = {
        NEW_YEARS_DAY: 'NEW_YEARS_DAY',
        MARTIN_LUTHER_KING_JR_DAY: 'MARTIN_LUTHER_KING_JR_DAY',
        PRESIDENTS_DAY: 'PRESIDENTS_DAY',
        MEMORIAL_DAY: 'MEMORIAL_DAY',
        INDEPENDENCE_DAY: 'INDEPENDENCE_DAY',
        LABOR_DAY: 'LABOR_DAY',
        VETERANS_DAY: 'VETERANS_DAY',
        THANKSGIVING_DAY: 'THANKSGIVING_DAY',
        CHRISTMAS_DAY: 'CHRISTMAS_DAY',
        INDIGENOUS_PEOPLES_DAY: 'INDIGENOUS_PEOPLES_DAY',
        JUNETEENTH: 'JUNETEENTH',
    };
    Pegasus.estimatedDeliveryDisplayLocationUnion = z.union([
        z.literal('EXTENSION'),
        z.literal('ADD_TO_DESCRIPTION'),
    ]);
    Pegasus.EstimatedDeliveryStrategy = {
        STATIC: 'STATIC',
        CARRIER_PROVIDED: 'CARRIER_PROVIDED',
    };
    // ! When updating, changing the delivery estimate ensure that
    // ! the changes are reflected in packages/corso-types/corso-shopify-extensions/shared.ts
    Pegasus.provideEstimatedDeliveryDate = z.object({
        strategy: enumToZodLiteralUnion(Pegasus.EstimatedDeliveryStrategy),
        estimatedDeliveryShippingCutOffTime: z.optional(z.string().pipe(z.coerce.number()).or(z.number())),
        estimatedDeliveryRangeStartDays: z.number().nonnegative().default(3),
        estimatedDeliveryRangeEndDays: z.number().nonnegative().optional(),
        estimatedDeliveryDisplayLocation: Pegasus.estimatedDeliveryDisplayLocationUnion,
        estimatedDeliveryFulfillmentTz: z.string().optional(),
        carrierEstimatedFulfillmentDays: z.number().nonnegative().optional(),
        estimatedDeliveryHolidays: z
            .array(enumToZodLiteralUnion(Pegasus.USHoliday))
            .optional()
            .default(Object.values(Pegasus.USHoliday)),
        estimatedDeliveryBlackoutDates: z.array(z.string()).optional(),
        estimatedTargetStoreShipRateIds: z.array(z.number()),
    });
    const applyFixedFee = z.object({
        kind: z.literal(Pegasus.QuoteModification.APPLY_FIXED_FEE),
        amount: z.number().nonnegative(),
        applyPerItem: z.boolean().default(false),
        fixedFeeStoreShipRateIds: z.array(z.number()).optional().default([]),
    });
    const applyPercentageFee = z.object({
        kind: z.literal(Pegasus.QuoteModification.APPLY_PERCENTAGE_FEE),
        percentage: z.number().nonnegative(),
        percentageFeeStoreShipRateIds: z.array(z.number()).optional().default([]),
    });
    const actionUnion = z.union([
        z.literal('ADD'),
        z.literal('REMOVE'),
        z.literal('REPLACE'),
    ]);
    const addOrRemoveRates = z.object({
        kind: z.literal(Pegasus.QuoteModification.ADD_OR_REMOVE_RATES),
        action: actionUnion,
        addOrRemoveStoreShipRateIds: z.array(z.number()),
    });
    Pegasus.ShippingDiscountType = {
        percentage: 'percentage',
        fixedAmount: 'fixedAmount',
        removePlusPricing: 'removePlusPricing',
    };
    Pegasus.shippingDiscount = z.object({
        kind: z.literal(Pegasus.QuoteModification.APPLY_SHIPPING_DISCOUNT),
        discountMessage: z.string().optional(),
        discountType: enumToZodLiteralUnion(Pegasus.ShippingDiscountType),
        discountAmount: z.number().nonnegative(),
        discountStoreShipRateIds: z.array(z.number()).optional().default([]),
        isCheckboxApplicationEnabled: z.boolean().optional().default(true),
    });
    const modifications = z.discriminatedUnion('kind', [
        applyPercentageFee,
        applyFixedFee,
        addOrRemoveRates,
        Pegasus.shippingDiscount,
    ]);
    Pegasus.eventQuoteOrderShipmentModify = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.quoteOrderShipmentModify}`),
        params: z.object({
            checkoutRateModifications: z.array(modifications),
        }),
    });
    Pegasus.eventQuoteOrderShipmentDeliveryEstimate = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.quoteOrderShipmentDeliveryEstimate}`),
        params: z.object({
            deliveryEstimateConfigs: z.array(Pegasus.provideEstimatedDeliveryDate),
        }),
    });
    // ------------- restock inventory ---------------------
    Pegasus.RestockPlatform = {
        SHOPIFY: 'SHOPIFY',
        XORO: 'XORO',
    };
    const baseRestockInventoryEventParams = z.object({
        restockPlatform: enumToZodLiteralUnion(Pegasus.RestockPlatform),
    });
    Pegasus.RestockName = {
        available: 'available',
        damaged: 'damaged',
        none: 'none',
    };
    const shopifyRestockInventoryEventParams = baseRestockInventoryEventParams.extend({
        restockPlatform: z.literal(Pegasus.RestockPlatform.SHOPIFY),
        restockLocationIdFromPlatform: z.string().optional(),
        shopifyRestockName: enumToZodLiteralUnion(Pegasus.RestockName),
    });
    const zoroRestockInventoryEventParams = baseRestockInventoryEventParams.extend({
        restockPlatform: z.literal(Pegasus.RestockPlatform.XORO),
    });
    Pegasus.eventRestockInventory = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.restockInventory}`),
        params: z.discriminatedUnion('restockPlatform', [
            shopifyRestockInventoryEventParams,
            zoroRestockInventoryEventParams,
        ]),
    });
    // ------------- order edit ---------------------
    Pegasus.OrderEditType = {
        CANCEL_ORDER: 'CANCEL_ORDER',
        UPDATE_SHIPPING_ADDRESS: 'UPDATE_SHIPPING_ADDRESS',
        REMOVE_PACKAGE_PROTECTION: 'REMOVE_PACKAGE_PROTECTION',
        MODIFY_QUANTITY: 'MODIFY_QUANTITY',
        UPDATE_EMAIL: 'UPDATE_EMAIL',
        UPDATE_SHIPPING_LINE: 'UPDATE_SHIPPING_LINE',
        ADD_DISCOUNT_CODE: 'ADD_DISCOUNT_CODE',
    };
    // Minutes of CS handle time avoided per self-served edit. Conservative end of
    // published retail/ecommerce AHT benchmarks (3:29 floor – 6:25 median; see
    // https://www.ltvplus.com/customer-service/average-handle-time/,
    // https://www.edesk.com/blog/ecommerce-customer-service-statistics/) plus
    // action-specific references:
    //   CANCEL_ORDER - 15 min cited per cancel ticket
    //     (https://www.accounteditor.com/blog/reduce-shopify-order-cancellations-self-service-editing);
    //     Gorgias excludes cancel from self-serve because it always escalates
    //     (https://docs.gorgias.com/en-US/self-service-statistics-81942);
    //     40 min/edit pre-self-serve in Cleverific Northwood Candle case study
    //     (https://cleverific.com/success-stories).
    //   UPDATE_SHIPPING_ADDRESS — 5–10 min via support
    //     (https://www.revize.app/blog/how-to-change-shipping-address-on-shopify-after-checkout-2025-guide).
    //   MODIFY_QUANTITY / UPDATE_SHIPPING_LINE — retail AHT band plus price
    //     recalc, capture/refund, inventory adjustment.
    //   REMOVE_PACKAGE_PROTECTION / UPDATE_EMAIL — lightest edits, near the
    //     retail AHT floor (still a ticket: read, act, reply, close).
    Pegasus.OrderEditMinuteSavedMultiplier = {
        [Pegasus.OrderEditType.CANCEL_ORDER]: 5,
        [Pegasus.OrderEditType.UPDATE_SHIPPING_ADDRESS]: 5,
        [Pegasus.OrderEditType.REMOVE_PACKAGE_PROTECTION]: 3,
        [Pegasus.OrderEditType.MODIFY_QUANTITY]: 4,
        [Pegasus.OrderEditType.UPDATE_EMAIL]: 2,
        [Pegasus.OrderEditType.UPDATE_SHIPPING_LINE]: 4,
        [Pegasus.OrderEditType.ADD_DISCOUNT_CODE]: 4,
    };
    Pegasus.OrderEditHoldTag = 'CORSO-OE-HOLD';
    Pegasus.OrderEditDisplayContent = {
        [Pegasus.OrderEditType.CANCEL_ORDER]: {
            name: 'Cancel Order',
            customerDescription: 'Request to cancel your order.',
            merchantDescription: 'Let customers request order cancellation.',
        },
        [Pegasus.OrderEditType.UPDATE_SHIPPING_ADDRESS]: {
            name: 'Update Shipping Address',
            customerDescription: 'Change the shipping address for your order.',
            merchantDescription: 'Allow customers to update their shipping address.',
        },
        [Pegasus.OrderEditType.REMOVE_PACKAGE_PROTECTION]: {
            name: 'Remove Package Protection',
            customerDescription: 'Remove shipping protection from your order.',
            merchantDescription: 'Let customers remove package protection.',
        },
        [Pegasus.OrderEditType.MODIFY_QUANTITY]: {
            name: 'Adjust Product Quantity',
            customerDescription: 'Change the quantity of items on your order.',
            merchantDescription: 'Allow customers to add or remove quantity on existing items.',
        },
        [Pegasus.OrderEditType.UPDATE_EMAIL]: {
            name: 'Update Email',
            customerDescription: 'Change the email address on your order.',
            merchantDescription: 'Let customers update their email address.',
        },
        [Pegasus.OrderEditType.UPDATE_SHIPPING_LINE]: {
            name: 'Change Shipping Method',
            customerDescription: 'Upgrade or change the shipping method on your order.',
            merchantDescription: 'Allow customers to upgrade or change their shipping method.',
        },
        [Pegasus.OrderEditType.ADD_DISCOUNT_CODE]: {
            name: 'Apply Discount Code',
            customerDescription: 'Apply a discount code to your order.',
            merchantDescription: 'Let customers apply a discount code post-purchase and receive a refund for the difference.',
        },
    };
    // the code an applied edit is saved under, which is also what analytics groups by
    Pegasus.OrderEditStoredType = {
        [Pegasus.OrderEditType.UPDATE_SHIPPING_ADDRESS]: 'Update_Shipping_Address',
        [Pegasus.OrderEditType.CANCEL_ORDER]: 'Cancel_Order',
        [Pegasus.OrderEditType.REMOVE_PACKAGE_PROTECTION]: 'Remove_Package_Protection',
        [Pegasus.OrderEditType.MODIFY_QUANTITY]: 'Modify_Quantity',
        [Pegasus.OrderEditType.UPDATE_EMAIL]: 'Update_Email',
        [Pegasus.OrderEditType.UPDATE_SHIPPING_LINE]: 'Update_Shipping_Line',
        [Pegasus.OrderEditType.ADD_DISCOUNT_CODE]: 'Add_Discount_code',
    };
    const editName = (editType) => Pegasus.OrderEditDisplayContent[editType].name;
    // keyed by the stored code, so a new edit type fails to compile until it is named here
    Pegasus.orderEditStoredTypeName = {
        Update_Shipping_Address: editName(Pegasus.OrderEditType.UPDATE_SHIPPING_ADDRESS),
        Cancel_Order: editName(Pegasus.OrderEditType.CANCEL_ORDER),
        Remove_Package_Protection: editName(Pegasus.OrderEditType.REMOVE_PACKAGE_PROTECTION),
        Modify_Quantity: editName(Pegasus.OrderEditType.MODIFY_QUANTITY),
        Update_Email: editName(Pegasus.OrderEditType.UPDATE_EMAIL),
        Update_Shipping_Line: editName(Pegasus.OrderEditType.UPDATE_SHIPPING_LINE),
        Add_Discount_code: editName(Pegasus.OrderEditType.ADD_DISCOUNT_CODE),
    };
    Pegasus.orderEditTypeUnion = z.union([
        z.literal(`${Pegasus.OrderEditType.CANCEL_ORDER}`),
        z.literal(`${Pegasus.OrderEditType.UPDATE_SHIPPING_ADDRESS}`),
        z.literal(`${Pegasus.OrderEditType.REMOVE_PACKAGE_PROTECTION}`),
        z.literal(`${Pegasus.OrderEditType.MODIFY_QUANTITY}`),
        z.literal(`${Pegasus.OrderEditType.UPDATE_EMAIL}`),
        z.literal(`${Pegasus.OrderEditType.UPDATE_SHIPPING_LINE}`),
        z.literal(`${Pegasus.OrderEditType.ADD_DISCOUNT_CODE}`),
    ]);
    const baseOrderEditEventParams = z.object({
        storeRuleId: z.number().optional(),
        editConfirmLabel: z.string().optional(),
        editSuccessLabel: z.string().optional(),
    });
    Pegasus.orderEditCancelOrderActionSchema = baseOrderEditEventParams.extend({
        editType: z.literal(`${Pegasus.OrderEditType.CANCEL_ORDER}`),
        shouldNotifyOnCancellation: z.boolean().default(true),
        shouldRestockOnCancellation: z.boolean().default(true),
    });
    Pegasus.orderEditUpdateShippingLineActionSchema = baseOrderEditEventParams.extend({
        editType: z.literal(`${Pegasus.OrderEditType.UPDATE_SHIPPING_LINE}`),
        allowedShippingLines: z
            .array(z.string())
            .min(1, 'Please specify at least one shipping line.')
            .max(5, 'Please specify no more than 5 shipping lines.'),
    });
    Pegasus.orderEditUpdateAddressActionSchema = baseOrderEditEventParams.extend({
        editType: z.literal(`${Pegasus.OrderEditType.UPDATE_SHIPPING_ADDRESS}`),
        allowDifferentCountryAddressEdit: z.boolean().optional(),
        shouldRecalculateTaxesOnAddressEdit: z.boolean().optional(),
    });
    Pegasus.orderEditRemovePackageProtection = baseOrderEditEventParams.extend({
        editType: z.literal(`${Pegasus.OrderEditType.REMOVE_PACKAGE_PROTECTION}`),
    });
    const modificationType = {
        ADD: 'ADD',
        REMOVE: 'REMOVE',
        BOTH: 'BOTH',
    };
    Pegasus.orderEditModifyQuantityActionSchema = baseOrderEditEventParams.extend({
        editType: z.literal(`${Pegasus.OrderEditType.MODIFY_QUANTITY}`),
        quantityModificationType: z.enum(modificationType),
        quantityModificationValue: z.number().int().positive(),
    });
    Pegasus.orderEditUpdateEmailActionSchema = baseOrderEditEventParams.extend({
        editType: z.literal(`${Pegasus.OrderEditType.UPDATE_EMAIL}`),
    });
    Pegasus.orderEditAddDiscountCodeActionSchema = baseOrderEditEventParams.extend({
        editType: z.literal(`${Pegasus.OrderEditType.ADD_DISCOUNT_CODE}`),
    });
    Pegasus.orderEditAction = z.discriminatedUnion('editType', [
        Pegasus.orderEditCancelOrderActionSchema,
        Pegasus.orderEditUpdateAddressActionSchema,
        Pegasus.orderEditRemovePackageProtection,
        Pegasus.orderEditModifyQuantityActionSchema,
        Pegasus.orderEditUpdateEmailActionSchema,
        Pegasus.orderEditUpdateShippingLineActionSchema,
        Pegasus.orderEditAddDiscountCodeActionSchema,
    ]);
    Pegasus.eventOrderEditing = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.orderEditing}`),
        params: Pegasus.orderEditAction,
    });
    Pegasus.eventRegistrationDiscountIncentive = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.registrationDiscountIncentive}`),
        params: z.object({
            storeDiscountDefinitionId: z.number(),
            discountRedirectUrl: z.url(),
            discountValidityDays: z.number().nonnegative().optional(),
            discountCustomerMessage: z.string().optional(),
        }),
    });
    Pegasus.AdvancedExchangeMethod = {
        PAYMENT: 'PAYMENT', // Previously UPSELL
        PAYMENT_AND_PARTIAL_REFUND: 'PAYMENT_AND_PARTIAL_REFUND', // Previously PARTIAL_REFUND
        NO_PAYMENT_OR_REFUND: 'NO_PAYMENT_OR_REFUND', // Previously NO_PAYMENT
    };
    Pegasus.advancedExchangeMethodUnion = z.union([
        z.literal(`${Pegasus.AdvancedExchangeMethod.PAYMENT}`),
        z.literal(`${Pegasus.AdvancedExchangeMethod.PAYMENT_AND_PARTIAL_REFUND}`),
        z.literal(`${Pegasus.AdvancedExchangeMethod.NO_PAYMENT_OR_REFUND}`),
    ]);
    Pegasus.AdvancedExchangeSortCriteria = {
        ALPHABETICAL: 'ALPHABETICAL',
        NEWEST_FIRST: 'NEWEST_FIRST',
    };
    const advancedExchangeSortOptionUnion = z.union([
        z.literal(`${Pegasus.AdvancedExchangeSortCriteria.ALPHABETICAL}`),
        z.literal(`${Pegasus.AdvancedExchangeSortCriteria.NEWEST_FIRST}`),
    ]);
    const baseParamsOfferAdvancedExchange = z.object({
        isAdvancedExchangeFilterAndSearchEnabled: z
            .boolean()
            .default(true)
            .optional(),
        advancedExchangeSortCriteria: advancedExchangeSortOptionUnion.default(`${Pegasus.AdvancedExchangeSortCriteria.ALPHABETICAL}`),
        excludedAdvancedExchangeOptionNames: z.array(z.string()).default(['Title']),
        minInventoryAvailableToCustomer: helperSchema.nonNegativeNumber.nullish(),
        advancedExchangeMethod: Pegasus.advancedExchangeMethodUnion.default('NO_PAYMENT_OR_REFUND'),
    });
    Pegasus.eventOfferAdvancedExchange = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.offerAdvancedExchange}`),
        params: z.discriminatedUnion('exchangeKind', [
            baseParamsOfferAdvancedExchange
                .extend({
                exchangeKind: z.literal('product'),
                isNoAdjustmentVariantExchangeEnabled: z
                    .boolean()
                    .default(false)
                    .optional(),
                storeProductTags: z.array(z.string()).optional(),
                matchAllTags: z.boolean().default(false).optional(),
                storeProductGroupIds: z.array(z.number()),
            })
                .refine((data) => !!data.storeProductTags?.length ||
                !!data.storeProductGroupIds.length, {
                error: 'Please specify at least one product tag or product group.',
                path: ['storeProductGroupIds'],
            }),
            baseParamsOfferAdvancedExchange.extend({
                exchangeKind: z.literal('variant'),
            }),
        ]),
    });
    const parcel = z.object({
        name: z.string(),
        length: z.number().nonnegative().min(1),
        width: z.number().nonnegative().min(1),
        height: z.number().nonnegative().min(1),
    });
    Pegasus.eventQuoteOrderShipmentParcel = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.quoteOrderShipmentParcel}`),
        params: z.object({
            parcel,
        }),
    });
    Pegasus.customReturnParcel = parcel
        .omit({
        name: true,
    })
        .extend({
        weight: z.number().nonnegative().optional(),
        name: z.string().optional(),
    });
    Pegasus.eventCustomizeReturnShipment = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.customizeReturnShipment}`),
        params: z.object({
            isApplicablePerLineItemQuantity: z.boolean().default(true),
            fileUrlCta: z
                .string()
                .max(32, 'Must be less than 32 characters')
                .optional(),
            fileUrl: z.url().optional(),
            returnParcels: z
                .array(Pegasus.customReturnParcel)
                .min(1, 'Please specify at least one parcel'),
        }),
    });
    Pegasus.eventMerchantPaidProtection = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.merchantPaidShippingProtection}`),
        params: z.object({
            shipProtectUnitId: z.number(),
        }),
    });
    Pegasus.eventSetOrderShippingTitle = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.setOrderShippingTitle}`),
        params: z.object({
            shippingTitle: z.string(),
        }),
    });
    // this is for the new EU legislation that goes live on June 19th
    Pegasus.eventRightToWithdraw = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.rightToWithdraw}`),
        params: z.object({
            rightToWithdrawTitle: z.string(),
            rightToWithdrawDescription: z.string(),
        }),
    });
    Pegasus.eventSpcAllowedResolutions = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.shipClaimAllowedResolutions}`),
        params: z.object({
            isGiftCardEnabled: z.boolean().optional(),
            shippingClaimResolutionMethods: z
                .array(z.enum(ClaimResolutionMethodEnum))
                .min(1),
        }),
    });
    Pegasus.eventSpcAllowedReorderLocations = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.shipClaimReorderLocations}`),
        params: z.object({
            reorderLocationIds: z.array(z.number()).min(1),
            minInventoryAvailable: helperSchema.nonNegativeNumber.nullish(),
        }),
    });
    Pegasus.eventSpcReorderShipping = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.shipClaimReorderShipping}`),
        params: z.discriminatedUnion('shippingTitleKind', [
            z.object({
                shippingTitleKind: z.literal('selection'),
                shippingTitles: z.array(z.string()).min(1),
            }),
            z.object({
                shippingTitleKind: z.literal('assignment'),
                shippingTitle: z.string(),
            }),
        ]),
    });
    Pegasus.eventSpcApplyOrderTags = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.shipApplyOrderTags}`),
        params: Pegasus.eventApplyOrderTags.shape.params.omit({ tagWithReason: true }),
    });
    Pegasus.eventSpcSlaNotification = z.object({
        storeRuleId: z.number().optional(),
        type: z.literal(`${Pegasus.EventType.shipClaimSlaAlert}`),
        params: z.object({
            alert: z.object({
                title: helperSchema.nonEmptyString.max(40, {
                    message: 'Title must be less than 40 characters',
                }),
                message: helperSchema.nonEmptyString.max(150, {
                    message: 'Message must be less than 150 characters',
                }),
                variant: z.union([
                    z.literal('warning'),
                    z.literal('info'),
                    z.literal('danger'),
                ]),
            }),
            // ? disables finalize in the merchant-ui; manual refunds and reorders stay available
            shouldBlockFinalization: z.boolean().optional(),
        }),
    });
    // ----------- type relationship enforcement --------------
    Pegasus.hooksForEvent = {
        // order lookup
        [Pegasus.EventType.orderEditing]: [Pegasus.Hook.orderLookup],
        [Pegasus.EventType.modifyResolutionWindow]: [Pegasus.Hook.orderLookup],
        [Pegasus.EventType.offerInstantExchange]: [Pegasus.Hook.orderLookup],
        [Pegasus.EventType.allowClaimTypeSelection]: [Pegasus.Hook.orderLookup],
        [Pegasus.EventType.rightToWithdraw]: [Pegasus.Hook.orderLookup],
        // after reason selection
        [Pegasus.EventType.askAPolicyEnforcingQuestion]: [Pegasus.Hook.afterReasonSelection],
        [Pegasus.EventType.collectCustomFields]: [Pegasus.Hook.afterReasonSelection],
        // exchange product selection
        [Pegasus.EventType.offerAdvancedExchange]: [Pegasus.Hook.exchangeProductSelection],
        // return shipment quote
        [Pegasus.EventType.returnShippingConfig]: [Pegasus.Hook.returnShipmentQuote],
        // before claim submission
        [Pegasus.EventType.chargeForReturnLabel]: [Pegasus.Hook.beforeClaimSubmission],
        [Pegasus.EventType.chargeForExchangeOrderShipping]: [Pegasus.Hook.beforeClaimSubmission],
        [Pegasus.EventType.modifyIncentives]: [Pegasus.Hook.beforeClaimSubmission],
        [Pegasus.EventType.applyFee]: [Pegasus.Hook.beforeClaimSubmission],
        // claim created
        [Pegasus.EventType.applyClaimTags]: [
            Pegasus.Hook.claimCreated,
            Pegasus.Hook.rmaWebhook,
            Pegasus.Hook.returnShipmentWebhook,
            Pegasus.Hook.returnShipmentCreated,
        ],
        [Pegasus.EventType.autoFinalizeClaim]: [
            Pegasus.Hook.rmaWebhook,
            Pegasus.Hook.returnShipmentWebhook,
            Pegasus.Hook.claimCreated,
        ],
        [Pegasus.EventType.allowCustomerToKeepItem]: [Pegasus.Hook.returnShipmentCreated],
        [Pegasus.EventType.customizeClaimLineItemInspection]: [
            Pegasus.Hook.beforeClaimLineItemInspection,
        ],
        [Pegasus.EventType.applyOrderTags]: [Pegasus.Hook.claimCreated, Pegasus.Hook.claimFinalized],
        [Pegasus.EventType.customizeClaimFinalizationSettings]: [Pegasus.Hook.claimFinalized],
        [Pegasus.EventType.shopNow]: [Pegasus.Hook.claimLineItemReview],
        // checkout + theme app + registration
        [Pegasus.EventType.productRegistrationSelection]: [
            Pegasus.Hook.registrationProductSelection,
        ],
        [Pegasus.EventType.restockInventory]: [
            Pegasus.Hook.claimFinalized,
            Pegasus.Hook.returnShipmentWebhook,
        ],
        [Pegasus.EventType.setOrderShippingTitle]: [Pegasus.Hook.claimFinalized],
        [Pegasus.EventType.quoteOrderShipment]: [Pegasus.Hook.orderCheckoutBegin],
        [Pegasus.EventType.quoteOrderShipmentModify]: [Pegasus.Hook.orderCheckoutQuoteShipping],
        [Pegasus.EventType.quoteOrderShipmentParcel]: [Pegasus.Hook.orderCheckoutQuoteShipping],
        [Pegasus.EventType.quoteOrderShipmentDeliveryEstimate]: [
            Pegasus.Hook.orderCheckoutQuoteShipping,
        ],
        [Pegasus.EventType.registrationDiscountIncentive]: [Pegasus.Hook.registrationCreated],
        [Pegasus.EventType.customizeReturnShipment]: [Pegasus.Hook.returnShipmentQuote],
        [Pegasus.EventType.merchantPaidShippingProtection]: [Pegasus.Hook.orderCreated],
        [Pegasus.EventType.createGorgiasTicket]: [Pegasus.Hook.claimCreated, Pegasus.Hook.claimFinalized],
        [Pegasus.EventType.applyLineItemFee]: [Pegasus.Hook.beforeClaimSubmission],
        [Pegasus.EventType.omitResolutionMethods]: [Pegasus.Hook.afterReasonSelection],
        [Pegasus.EventType.shipClaimReorderLocations]: [Pegasus.Hook.shippingClaimLookup],
        [Pegasus.EventType.shipClaimAllowedResolutions]: [Pegasus.Hook.shippingClaimLookup],
        [Pegasus.EventType.shipClaimSlaAlert]: [Pegasus.Hook.shippingClaimLookup],
        [Pegasus.EventType.shipClaimReorderShipping]: [Pegasus.Hook.shippingClaimLookup],
        [Pegasus.EventType.shipApplyOrderTags]: [Pegasus.Hook.shippingClaimFinalized],
    };
    Pegasus.eventsForHook = Object.values(Pegasus.Hook).reduce((efh, hook) => {
        // oxlint-disable-next-line no-param-reassign
        efh[hook] = Object.values(Pegasus.EventType).filter((event) => {
            const potentialHooks = Pegasus.hooksForEvent[event]; // TODO add @total-typescript/ts-reset for everything
            return potentialHooks.includes(hook);
        });
        return efh;
    }, {}); // TODO see if we can improve/eliminate this cast
    const registrationFactsBeforeCreation = [
        Fact.registrationEstimatedPurchaseDate,
        Fact.registrationChannel,
        Fact.registrationDaysSincePurchaseEstimate,
    ];
    const registrationFactsAfterCreation = [
        ...registrationFactsBeforeCreation,
        Fact.registrationEmailMarketingConsentCollected,
        Fact.registrationNewCustomerCreated,
    ];
    Pegasus.orderFacts = [
        Fact.orderIsGlobalE,
        Fact.orderShippingLineTitle,
        Fact.orderFinancialStatus,
        Fact.orderDiscountCode,
        Fact.orderCreated,
        Fact.orderCountry,
        Fact.orderProvince,
        Fact.orderGateway,
        Fact.orderTotal,
        Fact.orderTags,
        Fact.customerTags,
        Fact.orderNumber,
        Fact.customerEmail,
        Fact.orderChannel,
        Fact.orderProtectedByCorso,
        Fact.orderDaysSinceCreated,
        Fact.statusCustomer,
        Fact.customerTotalOrderCountAllTime,
        Fact.orderFulfillmentDisplayStatus,
        Fact.orderCanceled,
        Fact.orderFulfillmentLocationId,
        ...registrationFactsAfterCreation,
    ];
    Pegasus.lineItemFacts = [
        Fact.productTags,
        Fact.orderLineItemCustomPropertyName,
        Fact.productTypes,
        Fact.productCollections,
        Fact.productVendor,
        Fact.productSku,
        Fact.productGroupId,
        Fact.orderLineItemCompareAtPricePercentage,
    ];
    Pegasus.claimLineItemFacts = [
        Fact.reasonId,
        Fact.reasonCategoryCode,
        Fact.reasonDetailId,
        Fact.claimLineItemRequestedResolutionMethod,
        Fact.claimLineItemInspectionGrade,
        Fact.claimLineItemTotalQuantity,
        Fact.returnShipmentLocationId,
        Fact.claimLineItemWasResolvedExternally,
        ...Pegasus.lineItemFacts,
    ];
    Pegasus.shippingClaimFacts = [
        Fact.shippingClaimTotal,
        Fact.shippingClaimResolutionMethod,
        Fact.shippingClaimReason,
        Fact.shippingClaimLineItemReorderSku,
    ];
    const claimFactsBeforeCreation = [Fact.claimType, Fact.claimTotal];
    const claimFactsAfterCreation = [
        ...claimFactsBeforeCreation,
        Fact.claimIsGiftReturn,
        Fact.claimRiskLevel,
        Fact.claimIsShopNow,
    ];
    Pegasus.factsForHook = {
        [Pegasus.Hook.orderCreated]: [
            Fact.orderShippingLineTitle,
            Fact.orderTags,
            Fact.orderChannel,
            Fact.orderTotal,
            Fact.orderRechargeProtectedPrepaid,
        ],
        [Pegasus.Hook.returnShipmentQuote]: [
            ...Pegasus.orderFacts,
            ...Pegasus.claimLineItemFacts,
            ...claimFactsBeforeCreation,
            Fact.exchangeOrderTotal,
            Fact.claimLineItemCustomFieldResponse,
        ],
        [Pegasus.Hook.orderLookup]: [...Pegasus.orderFacts, ...Pegasus.lineItemFacts],
        [Pegasus.Hook.afterReasonSelection]: [
            ...Pegasus.orderFacts,
            ...Pegasus.claimLineItemFacts,
            ...claimFactsBeforeCreation,
        ],
        [Pegasus.Hook.claimLineItemReview]: [
            ...Pegasus.orderFacts,
            ...Pegasus.claimLineItemFacts,
            ...claimFactsBeforeCreation,
            Fact.exchangeOrderTotal,
        ],
        [Pegasus.Hook.beforeClaimSubmission]: [
            ...Pegasus.orderFacts,
            ...Pegasus.claimLineItemFacts,
            ...claimFactsBeforeCreation,
            Fact.claimIsShopNow,
            Fact.exchangeOrderTotal,
            Fact.claimLineItemCustomFieldResponse,
        ],
        [Pegasus.Hook.returnShipmentCreated]: [
            ...Pegasus.orderFacts,
            ...Pegasus.claimLineItemFacts,
            Fact.claimLineItemTotal,
            Fact.claimLineItemCustomFieldResponse,
            ...claimFactsAfterCreation,
        ],
        [Pegasus.Hook.orderCheckoutBegin]: [Fact.orderCountry, Fact.orderProvince],
        [Pegasus.Hook.claimCreated]: [
            ...Pegasus.orderFacts,
            ...Pegasus.claimLineItemFacts,
            ...claimFactsAfterCreation,
            Fact.claimLineItemCustomFieldResponse,
            Fact.customerTotalWarrantyCountLastYear,
        ],
        [Pegasus.Hook.beforeClaimLineItemInspection]: [
            ...Pegasus.orderFacts,
            ...Pegasus.claimLineItemFacts,
            Fact.claimType,
            Fact.claimLineItemCustomFieldResponse,
        ],
        [Pegasus.Hook.returnShipmentWebhook]: [
            ...Pegasus.orderFacts,
            ...Pegasus.claimLineItemFacts,
            ...claimFactsAfterCreation,
            Fact.customerTotalReturnCountLastYear,
            Fact.returnShipmentStatus,
            Fact.claimLineItemCustomFieldResponse,
        ],
        [Pegasus.Hook.rmaWebhook]: [
            ...Pegasus.orderFacts,
            ...Pegasus.claimLineItemFacts,
            ...claimFactsAfterCreation,
            Fact.rmaStatus,
            Fact.rmaAllItemsReceived,
            Fact.rmaDisposition,
            Fact.claimLineItemCustomFieldResponse,
        ],
        [Pegasus.Hook.claimFinalized]: [
            ...Pegasus.orderFacts,
            ...Pegasus.claimLineItemFacts,
            ...claimFactsAfterCreation,
            Fact.claimTags,
        ],
        [Pegasus.Hook.shippingClaimLookup]: [
            ...Pegasus.orderFacts,
            ...Pegasus.shippingClaimFacts,
            Fact.userRole,
            Fact.productGroupId,
        ],
        [Pegasus.Hook.registrationProductSelection]: registrationFactsBeforeCreation,
        [Pegasus.Hook.orderCheckoutQuoteShipping]: [
            Fact.productGroupId,
            Fact.customerTags,
            Fact.orderFulfillmentLocationId,
            Fact.intelligemsTestGroupId,
            Fact.productSku,
            Fact.productVendor,
            Fact.orderCountry,
            Fact.orderProvince,
            Fact.customerSegmentId,
            Fact.giftCardIssuedByCorso,
        ],
        [Pegasus.Hook.exchangeProductSelection]: [Fact.productGroupId, Fact.productTags],
        [Pegasus.Hook.registrationCreated]: [
            ...registrationFactsAfterCreation,
            ...Pegasus.lineItemFacts,
            Fact.customerEmail,
        ],
        [Pegasus.Hook.shippingClaimFinalized]: [...Pegasus.orderFacts, ...Pegasus.shippingClaimFacts],
    };
    /** Derived from Zod schema for fact expressions. */
    function operatorForFact(fact) {
        const valueType = Pegasus.factValueType[fact];
        return Pegasus.valueOperators[valueType];
    }
    Pegasus.operatorForFact = operatorForFact;
    // factExpression[fact].shape.operator.options.map((option) => option.value);
    /**
     * Derived from Zod schema for fact expressions.
     * Given a fact, it's definition should handle the relationship between the fact, operator, and value.
     * As some point these might need to become independent, where a fact defines shape of it's value, and the operators available are enforced by the resulting expressions.
     */
    function valueSchemaForFact(fact) {
        const valueType = Pegasus.factValueType[fact];
        return Pegasus.valueTypeSchema[valueType];
    }
    Pegasus.valueSchemaForFact = valueSchemaForFact;
    // ----------- event + rule schema ------------
    // todo: enforce all event schemas
    Pegasus.eventSchema = z.union([
        Pegasus.eventSetOrderShippingTitle,
        Pegasus.eventOrderEditing,
        Pegasus.eventOfferAdvancedExchange,
        Pegasus.eventModifyResolutionWindow,
        Pegasus.eventOfferInstantExchange,
        Pegasus.eventApplyClaimTags,
        Pegasus.eventAllowClaimTypeSelection,
        Pegasus.eventCollectCustomFields,
        Pegasus.eventAutoFinalizeClaim,
        Pegasus.eventPolicyEnforcement,
        Pegasus.eventClaimFinalizationSettings,
        Pegasus.eventApplyFee,
        Pegasus.eventModifyIncentives,
        Pegasus.eventChargeForReturnLabel,
        Pegasus.eventChargeForExchangeOrderShipping,
        Pegasus.eventAllowCustomerToKeepItem,
        Pegasus.eventProductRegistrationSelection,
        Pegasus.eventReturnShippingConfig,
        Pegasus.eventApplyOrderTags,
        Pegasus.eventCustomizeClaimLineItemInspection,
        Pegasus.eventQuoteOrderShipment,
        Pegasus.eventQuoteOrderShipmentModify,
        Pegasus.eventQuoteOrderShipmentParcel,
        Pegasus.eventQuoteOrderShipmentDeliveryEstimate,
        Pegasus.eventRestockInventory,
        Pegasus.eventShopNow,
        Pegasus.eventRegistrationDiscountIncentive,
        Pegasus.eventCustomizeReturnShipment,
        Pegasus.eventMerchantPaidProtection,
        Pegasus.eventCreateGorgiasTicket,
        Pegasus.eventRightToWithdraw,
        Pegasus.eventApplyLineItemFee,
        Pegasus.eventOmitResolutionMethods,
        Pegasus.eventSpcAllowedResolutions,
        Pegasus.eventSpcAllowedReorderLocations,
        Pegasus.eventSpcSlaNotification,
        Pegasus.eventSpcReorderShipping,
        Pegasus.eventSpcApplyOrderTags,
    ]);
    Pegasus.eventsSchemaArray = z.array(Pegasus.eventSchema);
    Pegasus.ruleSchema = z.object({
        priority: z
            .number('Must be a number')
            .positive('Must be greater than zero')
            .int('Must be a whole number'), // ! 1 is highest priority, with decreasing priority as the number increases
        conditions: z.union([allConditionSchema, anyConditionSchema]),
        event: Pegasus.eventSchema,
        storeRuleId: z.number().optional(),
    });
})(Pegasus || (Pegasus = {}));
//# sourceMappingURL=pegasus.js.map